<template>
  <div class="user_asset_all">
    <tab :tabList="tabList" @tabChange="handleTabChange"></tab>
    <!-- 搜索 -->
    <div class="api-search">
      <el-form size="small" :inline="true" class="demo-form-inline">
        <span style="width:100px;">
          <el-form-item label="资产名称" >
          <el-input
            size="small"
            placeholder="请输入资产名称"
            v-model="query.name"
            class="box-width"
          ></el-input>
        </el-form-item>
        </span>
        <el-form-item label="所属接口">
          <el-select v-model="query.api_id" class="box-width">
            <el-option
              v-for="item in typeOptions"
              :value="item.api_id"
              :label="item.name"
              :key="item.api_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="管理账号">
          <el-input
            size="small"
            placeholder="请输入管理账号"
            v-model="query.account"
            class="box-width"
          ></el-input>
        </el-form-item>
        <el-form-item label="区间查询">
          <el-select v-model="defaultTimes" class="box-width">
            <el-option
              v-for="item in typeDate"
              :value="item.times"
              :label="item.name"
              :key="item.times"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始">
          <el-date-picker
            class="date-width"
            type="datetime"
            v-model="query.begin_time"
            placeholder="请选择开始时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束">
          <el-date-picker
          class="date-width"
            type="datetime"
            v-model="query.end_time"
            placeholder="请选择到期时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            size="small"
            type="primary"
            icon="el-icon-search"
            @click="submitSearch"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <!-- 按钮 -->
    <div class="common-level-rail">
      <template v-if="currentTab != 'recycle'">
        <el-button
          size="small"
          type="danger"
          icon="el-icon-delete"
          @click="deleteAsset(selectedIdList)"
          >批量删除</el-button
        >
        <!-- <el-button
          v-if="currentTab === 'all'"
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="addAsset"
          >添加</el-button
        > -->
        <!-- <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="BatchAdd"
          >批量添加</el-button
        > -->
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="isWholePopup=!isWholePopup"
          >添加资产</el-button
        >
        <span class="size" v-if="total_amount">总资产续费金额：{{total_amount}}</span>
        <span class="size" v-if="money">当前页资产续费金额：{{money}}</span>
      </template>
      <template v-else>
        <el-button
          size="small"
          type="success"
          icon="el-icon-folder"
          v-auth="'/plus/api/app/recovery'"
          @click="recoveryAsset(selectedIdList)"
          >批量恢复</el-button
        >
        <el-button
          size="small"
          type="danger"
          icon="el-icon-delete"
          v-auth="'/plus/api/app/delete'"
          @click="dellAsset(selectedIdList)"
          >批量彻底删除</el-button
        >
      </template>
    </div>

    <my-table :showSelect="true" :loading="loading" :tableList="tableList" :tableOptionList="tableOptions" :current-page="query.page" :page-size="query.pageSize" :total="query.totalDataNumber" @selection-change="handleSelectChange" @current-change="handleCurrentChange" @size-change="handleSizeChange">
      <template slot="action" slot-scope="scope">
        <template v-if="currentTab != 'recycle'">
          <el-button @click="editAsset(scope.row)" type="primary" size="small">编辑</el-button>
          <el-button @click="manageAsset(scope.row)" type="success" size="small">管理</el-button>
          <el-button @click="deleteAsset(scope.row.user_asset_id)" type="danger" size="small">删除</el-button>
        </template>
        <template v-else>
          <el-button @click="recoveryAsset(scope.row.user_asset_id)" type="success" size="mini" v-auth="'/plus/api/app/recovery'">恢复</el-button>
          <el-button @click="dellAsset(scope.row.user_asset_id)" type="danger" size="mini" v-auth="'/plus/api/app/delete'">彻底删除</el-button>
        </template>
      </template>
      <template slot="account" slot-scope="scope">
        <template v-if="scope.row.remark.plugin_name === 'baota'">
          <a :href="['//' + scope.row.remark.account]" target="_blank">{{ scope.row.remark.account }}</a>
        </template>
        <template v-else>{{ scope.row.remark.account }}</template>
      </template>
      <template slot="status" slot-scope="scope">
        <el-tag :type="scope.row.status === 1 ? '' : 'danger'">{{ scope.row.status === 1 ? "正常" : "到期" }}</el-tag>
      </template>
      <template slot="type" slot-scope="scope">
        <span>{{ typeName(scope.row.type) }}</span>
      </template>
      <template slot="time" slot-scope="scope">
        <!-- <span>{{ scope.row.time }}</span> -->
        <span>{{ scope.row.begin_time }}</span><br/>
        <span>{{ scope.row.end_time }}</span>
      </template>
    </my-table>

<!--    <el-table :data="tableList" border style="width: 100%">-->
<!--      <el-table-column prop="user_asset_id" label="ID" width="70" ></el-table-column>-->
<!--      <el-table-column prop="remark.account" label="管理账号"></el-table-column>-->
<!--      <el-table-column prop="name" label="资产名称" ></el-table-column>-->
<!--      <el-table-column prop="status" label="状态" width="70">-->
<!--        <template slot-scope="scope">-->
<!--          <span :type="scope.row.status === 1 ? '' : 'danger'">{{ scope.row.status === 1 ? "正常" : "到期" }}</span>-->
<!--        </template>-->

<!--      </el-table-column>-->
<!--      <el-table-column prop="type" label="类型">-->
<!--        <template slot="type" slot-scope="scope">-->
<!--          <span>{{ typeName(scope.row.type) }}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="api_name" label="所属接口"></el-table-column>-->
<!--      <el-table-column prop="introduce" label="描述" width="220"></el-table-column>-->
<!--      <el-table-column prop="price" label="金额"></el-table-column>-->
<!--      <el-table-column prop="begin_time" label="购买/到期时间">-->
<!--        <template slot-scope="scope">-->
<!--          <span>{{ scope.row.begin_time }}</span><br/>-->
<!--          <span>{{ scope.row.end_time }}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column-->
<!--        prop="address"-->
<!--        label="地址">-->
<!--      </el-table-column>-->
<!--    </el-table>-->

    <!-- 控制面板 -->
    <div class="user_asset_all_iframe_box" v-if="url">
      <el-dialog
        :visible.sync="dialogVisible"
        @close="dialogFormVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="80%"
        title="控制面板"
        top="5vh"
      >
        <iframe
          class="user_asset_all_iframe"
          :src="url"
          width="100%"
          height="100%"
        >
        </iframe>
      </el-dialog>
    </div>

    <Edit
      v-if="open_edit && formItems && formData"
      :on_edit="on_edit"
      :open_edit="open_edit"
      :formData.sync="formData"
      :formItems="formItems"
      :autocompleteOptions="userList"
      @closeDialog="closeDialog"
      @submitForm="submitEditForm"
    ></Edit>
    <Add
      v-if="open_add"
      :open_add="open_add"
      :autocompleteOptions="userList"
      @closeDialog="closeDialog"
      @submitForm="submitAddForm"
    ></Add>
    <batch-add
      v-if="open_batchadd"
      :open_batchadd="open_batchadd"
      :autocompleteOptions="userList"
      @closeDialog="closeDialog"
      @submitForm="submitBatchForm"
    ></batch-add>
    <!-- <whole-popup v-if="isWholePopup"></whole-popup> -->
    <el-dialog
      title="请选择添加方式"
      :visible.sync="isWholePopup"
      width="20%">
      <div class="mar">
        <el-button
          class="width-100"
          v-if="currentTab === 'all'"
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="addAsset"
          >手动单个添加</el-button
        >
      </div>
      <div class="mar">
        <el-button
          class="width-100"
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="BatchAdd"
          >手动批量添加</el-button
        >
        <div>备注：适合非API手动添加</div>
      </div>
      <div class="mar">
        <el-button
          class="width-100"
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="$router.push('/plus/api/app')"
          >自动化添加</el-button
        >
        <div>备注：适合有API,支持宝塔</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        <!-- <el-button type="primary" @click="isWholePopup = false">确 定</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Table from "@/components/table/Table.vue";
import Tab from "@/components/tab/Tab.vue";
import Edit from "./part/Edit.vue";
import Add from "./part/Add.vue";
import BatchAdd from "./part/BatchAdd.vue";
import UserAssetApi from "@/api/userasset";
import Api from "@/api/api.js";
import myTime from "@/utils/time";
export default {
  components: {
    Tab,
    Edit,
    Add,
    MyTable: Table,
    BatchAdd,
  },
  data() {
    return {
      money: '',
      total_amount: '',//总资产
      begin_time: '',
      end_time: '',
      formItems: null,
      open_add: false,
      open_edit: false,
      on_edit: false,
      open_batchadd: false,
      tableOptions: [
        { prop: "user_asset_id", label: "ID", width: "70" },
        { prop: "remark.account", label: "管理账号", slotName: "account" },
        { prop: "name", label: "资产名称" },
        { prop: "status", label: "状态", slotName: "status", width: "70" },
        { prop: "type", label: "类型", slotName: "type" },
        { prop: "api_name", label: "所属接口" },
        { prop: "introduce", label: "描述", width: "220" },
        { prop: "price", label: "金额" },
        { prop: "time", label: "购买/到期时间",slotName: "time" },
        // { prop: "begin_time", label: "开始时间" },
        // { prop: "end_time", label: "到期时间" },
        {
          label: "操作",
          slotName: "action",
          other: { fixed: "right" },
          width: "220"
        }
      ],
      addVisible: false,
      tableList: [],
      loading: false,
      /* 查询条件 */
      query: {
        pageSize: 15,
        totalDataNumber: 15,
        curPage: 1,
      },
      dialogVisible: false,
      /* 删除列表 */
      selectedIdList: [],
      /* 资产类型 */
      type: [
        { label: "vhost", value: "虚拟主机" },
        { label: "cloud", value: "云服务器" },
        { label: "cdn", value: "CDN内容分发" },
        {
          label: "domain",
          value: "域名"
        },
        { label: "dns", value: "域名解析" },
        { label: "ssl", value: "域名证书" },
        { label: "web", value: "智能建站" },
        { label: "other", value: "其他资产" }
      ],
      /* 接口类型 */
      typeOptions: [],
      defaultTimes: 1,
      /* 查询时间方式 */
      typeDate: [
        {name: '开始时间',times: 1},
        {name: '到期时间',times: 2},
      ],
      url: null,
      currentTab: "all",
      tabList: [
        { label: "全部资产", value: { name: "all", key: "is_delete", num: 0 } },
        { label: "即将到期", value: { name: "expire", key: "expire", num: 1 } },
        { label: "7天到期", value: { name: "7day", key: "seven", num: 1 } },
        { label: "已到期", value: { name: "expired", key: "status", num: 2 } },
        {
          label: "回收站",
          value: { name: "recycle", key: "is_delete", num: 1 }
        }
      ],
      formData: null,
      userList: [],
      isWholePopup: false,
    };
  },
  created() {
    this.init();
  },
  computed: {
    getTime() {
      return value => {
        return time.formatTime(value);
      };
    },
    typeName() {
      return value => {
        return (this.type.find(item => item.label === value) || {}).value;
      };
    }
  },
  methods: {
    /* 初始化 */
    init() {
      this.getData();
      this.getApiType();
      this.getUserList();
    },

    /* 恢复资产 */
    recoveryAsset(id) {
      if (typeof id === "number" || id.length > 0) {
        this.$confirm(
          `此操作将 ${id.length ? id.length : 1} 条恢复改数据, 是否继续?`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "success"
          }
        )
          .then(async () => {
            this.loading = true;
            const res = await UserAssetApi.recycleUserAsset({
              user_asset_id: id
            });
            this.$message({
              message: res.msg,
              type: "success"
            });
            this.getData();
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    selectOption(value){
      if(value==1) {
        console.log(value)
        this.open_add = true;
      } else if(value==2) {
        console.log(value)
        this.open_batchadd = true;
      }else if(value==3) {
        console.log(value)
      }
      this.value=''
    },

    /* 彻底删除 */
    dellAsset(id) {
      if (typeof id === "number" || id.length > 0) {
        this.$confirm(
          `此操作将 ${id.length ? id.length : 1} 彻底删除该记录, 是否继续?`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(async () => {
            this.loading = true;
            const res = await UserAssetApi.dellUserAsset({
              user_asset_id: id
            });
            this.$message({
              message: res.msg,
              type: "success"
            });
            this.getData();
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },

    /* 添加资产 */
    addAsset() {
      this.open_add = true;
    },
    /* 批量添加 */
    BatchAdd() {
      this.open_batchadd = true;
    },

    /* 处理编辑 */
    async editAsset(row) {
      this.loading = true;
      try {
        const res = await UserAssetApi.getEdit({
          plugin_name: row.remark.plugin_name
        });
        this.initFormItems(row);
        this.formItems = [...res.data, ...this.formItems];
        if (row.remark.vhost_name) {
          this.formData = { ...row, ...row.remark };
        } else {
          this.initFormData();
          this.formData = { ...row, ...this.formData, ...row.remark };
        }
        this.open_edit = true;
      } catch (error) {
        this.$message({
          message: error,
          type: "error"
        });
      }
      this.loading = false;
    },

    /* 处理添加 */
    async handleAdd() {
      this.loading = true;
      const res = await UserAssetApi.getEdit({
        plugin_name: row.remark.plugin_name
      });
      this.initFormItems();
      this.formItems = [...res.data, ...this.formItems];
      this.initFormData();
      this.loading = false;
      this.open_edit = true;
    },

    /* 提交编辑表单 */
    async submitEditForm(formdata) {
      try {
        const formatData = {
          ...formdata,
          remark: { ...formdata.remark, ...formdata }
        };
        const res = await UserAssetApi.saveUserAsset(formatData);
        this.$message({
          message: res.msg,
          type: "success"
        });
        this.initFormData();
        this.initFormItems();
        this.open_edit = false;
        this.getData();
      } catch (error) {
        this.on_edit=false;
      }
    },

    /* 提交添加表单 */
    async submitAddForm(formdata) {
      try {
        const res = await UserAssetApi.addUserAsset(formdata);
        this.closeDialog(true);
        this.$message({
          message: res.msg,
          type: "success"
        });
      } catch (error) {}
    },
    /* 提交批量添加表单 */
    async submitBatchForm(formdata){
      // console.log('indexformatData',formdata)
      this.$message({
        message: '添加成功',
        type: "success"
      });
      try {
        const res = await UserAssetApi.batchUserAsset(formdata);
      } catch (error) {}
      this.closeDialog(true);
    },

    /* 关闭编辑框 */
    async closeDialog(reflush = false) {
      this.open_add = false;
      this.open_edit = false;
      this.open_batchadd = false;
      this.isWholePopup = false;
      if (reflush) {
        await this.getData();
      }
      this.init()
    },

    /* 初始化表单子项 */
    initFormItems(row = {}) {
      console.log(row)
      this.formItems = [
        {
          name: "price",
          placeholder: "续费金额",
          rules: { required: false, message: "请输入续费金额", trigger: "blur" },
          text: "续费金额",
          type: "number",
          defaultvalue: row.price || 0
        },
        {
          text: "合同",
          image: row.contract,
          type: 'contract',
        },
        {
          name: "other_user_name",
          placeholder: "请选择已存在的用户",
          rules: {
            required: true,
            message: "请选择已存在的用户",
            trigger: "change"
          },
          text: "所属用户",
          type: "autocomplete",
          option: {
            "value-key": "nickName"
          }
        },
        {
          name: "begin_time",
          placeholder: "请选择开始时间",
          rules: { required: true, message: "请选择开始时间", trigger: "blur" },
          text: "开始时间",
          type: "datetime",
          defaultvalue: row.begin_time || new Date().valueOf()
        },
        {
          name: "end_time",
          placeholder: "请选择到期时间",
          rules: { required: true, message: "请选择到期时间", trigger: "blur" },
          text: "到期时间",
          type: "datetime",
          defaultvalue: row.end_time || myTime.add(new Date(), 1, "y")
        },
        {
          name: "sort",
          placeholder: "请选择排序",
          rules: { required: true, message: "请选择排序", trigger: "blur" },
          text: "排序",
          type: "number",
          defaultvalue: row.sort || 50
        }
      ];
    },

    /* 初始化FormData */
    initFormData() {
      this.formData = this.formItems.reduce((acc, item) => {
        acc = { ...acc, [item.name]: item.defaultvalue };
        return acc;
      }, {});
    },

    /* 初始化搜索条件 */
    initQuery() {
      this.query = {
        pageSize: 15,
        totalDataNumber: 0,
        curPage: 1
      };
    },

    async getUserList() {
      const res = await UserAssetApi.getUserList({ pageSize: 99999 });
      this.userList = res.data.list.data.map(item => ({
        ...item,
        value: item.user_id
      }));
      let tem = { user_id: 0, nickName: "不绑定用户" };
      this.userList.unshift(tem);
    },
    /* tab改变 */
    handleTabChange(data) {
      this.currentTab = data.name;
      this.initQuery();
      this.query = { ...this.query, [data.key]: data.num };
      this.getData();
    },

    /* 模态框 */
    dialogFormVisible() {
      this.url = null;
      this.dialogVisible = false;
    },

    /* 获取数据 */
    async getData() {
      // 当页金额数
      let money = 0;
      try {
        this.loading = true;
        const res = await UserAssetApi.getUserAsset(this.query);
        this.query.totalDataNumber = res.data.list.total;
        this.query.pageSize = res.data.list.per_page;
        this.tableList = res.data.list.data;
        res.data.list.data.forEach(item => {
          money+=Number(item.price)
          item.time = item.begin_time + item.end_time;
        })
        console.log('money',money)
        this.money = money;
      } catch (error) {}
      this.loading = false;

      // 获取总金额数以后要改直接获取
      let total_amount = 0;
      try {
        const data = await UserAssetApi.getUserAsset(
          {
          pageSize:this.query.totalDataNumber,
          name:this.query.name,
          account:this.query.account,
          begin_time:this.query.begin_time,
          end_time:this.query.end_time,
        });
        data.data.list.data.forEach(item => {
          total_amount+=Number(item.price)
        })
        this.total_amount = total_amount;
      } catch (error) {}
      console.log('123123',this.tableList)
    },

    /* 选择ID */
    handleSelectChange(selection) {
      this.selectedIdList = selection.map(item => item.user_asset_id);
    },

    /* 删除资产按钮 */
    deleteAsset(id) {
      if (typeof id === "number" || id.length > 0) {
        this.$confirm(
          `此操作将永久删除 ${id.length || 1} 条记录, 是否继续?`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(async () => {
            this.loading = true;
            const res = await UserAssetApi.deleteUserAsset({
              user_asset_id: id
            });
            this.$message({
              message: res.msg,
              type: "success"
            });
            await this.getData();
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.$message({
          message: "请选择需要删除的记录",
          type: "error"
        });
      }
    },

    /* 管理资产按钮 */
    async manageAsset(row) {
      try {
        this.loading = true;
        const res = await UserAssetApi.getManager({
          api_id: row.api_id,
          plugin_name: row.remark.plugin_name,
          action_type: "admin_vhost" /* 不变值： admin_vhost */,
          user_asset_id: row.user_asset_id
        });
        if (res.data.web === 1) {
          window.open(res.data.url, "_blank");
        } else if (res.data.web === 2) {
          this.dialogVisible = true;
          this.url = res.data.url;
        }
      } catch (error) {}
      this.loading = false;
    },

    /* 获取接口类型 */
    async getApiType() {
      try {
        const res = await Api.getApiList();
        this.typeOptions = [
          { path: "", name: "全部", api_id: -1 },
          ...res.data.list.data
        ];
        console.log(this.typeOptions)
      } catch (error) {}
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      this.query.page = val;
      this.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.query.page = 1;
      this.query.pageSize = val;
      this.getData();
    },

    /* 搜索功能 */
    submitSearch() {
      this.query.defaultTimes=this.defaultTimes;
      this.getData();
    },

    /* 时间格式化 */
    formatTime(time) {
      return formatDate(time, "yyyy-MM-dd");
    }
  }
};
</script>

<style lang="scss" scoped>
// .el-date-editor.el-input, .el-date-editor.el-input__inner {
//     width: 170px;
// }
// >>>.el-input--small .el-input__inner {
//     width: 170px;
// }
.box-width {
  width: 150px;
}
.date-width {
  width: 180px;
}
.size {
  font-size: 14px;
  margin: 0 10px;
}
.user_asset_all /deep/ .el-pagination {
  margin-top: 20px;
  float: right;
}
.api-search {
  margin-top: 20px;
}
.user_asset_all_iframe_box /deep/ .el-dialog__header {
  padding: 10px;
}
.user_asset_all_iframe_box /deep/ .el-dialog__body {
  height: calc(100% - 20px);
  padding: 0;
}
.user_asset_all_iframe_box /deep/ .el-dialog__headerbtn {
  top: 4px;
  right: 6px;
}
.user_asset_all_iframe {
  border: none;
}
.user_asset_all_iframe_box /deep/ .el-dialog {
  height: 88%;
}
.mar{
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.width-100{
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/views/user_asset/all/index.vue